// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"H7-z"};